var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import styled from "@emotion/styled";
import { Tabs as MuiTabs, Tab as MuiTab, Box } from "@mui/material";
var TabStyles = {
    Wrapper: styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n        align-items: left;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n        .MuiTabs-scroller {\n            margin-bottom: 10px;\n        }\n    "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: left;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n        .MuiTabs-scroller {\n            margin-bottom: 10px;\n        }\n    "]))),
    Content: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 100%;\n        padding: 2rem var(--2, 16px);\n    "], ["\n        width: 100%;\n        padding: 2rem var(--2, 16px);\n    "]))),
};
export var Tabs = function (_a) {
    var _b, _c, _d;
    var elements = _a.elements, props = __rest(_a, ["elements"]);
    var baseUrl = new URL(window.location.href);
    var _e = React.useState(Number.parseInt((_c = (_b = baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.searchParams) === null || _b === void 0 ? void 0 : _b.get("tabIndex")) !== null && _c !== void 0 ? _c : "0")), selectedTab = _e[0], setSelectedTab = _e[1];
    var handleChange = function (event, newValue) {
        setSelectedTab(newValue);
    };
    return (_jsxs(TabStyles.Wrapper, { children: [_jsx(Box, __assign({ sx: {
                    bgcolor: "background.paper",
                    borderBottom: 1,
                    borderColor: "divider",
                } }, { children: _jsx(MuiTabs, __assign({ variant: "scrollable", allowScrollButtonsMobile: true, scrollButtons: "auto", value: selectedTab, onChange: handleChange, indicatorColor: "primary", textColor: "primary", "aria-label": "disabled tabs example" }, { children: elements.map(function (tab, index) { return (_jsx(MuiTab, { label: tab.label, onClick: function () { var _a, _b; return (_b = (_a = tab === null || tab === void 0 ? void 0 : tab.action) === null || _a === void 0 ? void 0 : _a.call(tab, index)) !== null && _b !== void 0 ? _b : null; } }, tab.label)); }) })) })), _jsx(TabStyles.Content, { children: (_d = elements[selectedTab]) === null || _d === void 0 ? void 0 : _d.component(props) })] }));
};
var templateObject_1, templateObject_2;
